import React from "react";

import { Switch, useRouteMatch } from "react-router-dom";
import { default as ActivityView } from "./activity-view";
import { default as ContainerRoute } from "@components/common/routing/container-route";

export default function MyWork({ responsiveStyles = {} }) {
  const { path } = useRouteMatch();

  const LessonWrapper = ({ lessonId, ...props }) => {
    return <ActivityView key={lessonId} {...props} />;
  };

  return (
    <Switch>
      <ContainerRoute
        exact={true}
        path={`${path}/:lessonId`}
        component={LessonWrapper}
        responsiveStyles={responsiveStyles}
      ></ContainerRoute>
    </Switch>
  );
}
